import { CanAccessFile } from '@oh-vcp/components-common';
import { useQuery, useQueryClient } from 'react-query';
import { apiGet } from './apiService';

const fetchCanAccessFile = async (fileId: string): Promise<CanAccessFile> => {
  return apiGet(`cases/canaccessfile/${fileId}`);
};

const useCanAccessFileService = (fileId?: string | undefined) => {
  const queryClient = useQueryClient();

  const result = useQuery<CanAccessFile | null>(
    ['useCanAccessFileService', fileId],
    () => fetchCanAccessFile(fileId!),
    {
      enabled: !!fileId,
      refetchOnWindowFocus: false
    }
  );

  const fetchCanAccessById = async (id: string): Promise<CanAccessFile | null> => {
    return queryClient.fetchQuery(['useCanAccessFileService', id], () => fetchCanAccessFile(id));
  };

  return {
    ...result,
    fetchCanAccessById
  };
};

export default useCanAccessFileService;
